import React from "react";
import blockchain from "../../images/blockchain/blockchain.svg";

const BlockChainContent = (props) => {
  return (
    <section
      id="id_ico_about_section "
      className={`ico_about_section section_space section_decoration bg-white ${props.abClass}`}
    >
      <div className="container">
        <div className="row justify-content-lg-center py-4">
          <div className="col-lg-8">
            <div
              className="ico_heading_block"
              data-aos="fade-up"
              data-aos-duration="600"
            >
              <h2 className="heading_text text-dark text-center mb-0">
                TopCoin UK Blockchain
              </h2>
            </div>
          </div>
        </div>
        <div className="row justify-content-lg-between">
          <div className="col-lg-6">
            <p className="text-dark fw-bold opacity-50 ">
              The TopCoin UK Blockchain, Powering Trust, Tracking, and Rewards
            </p>
            <p className="text-dark fw-bold opacity-50 ">
              Every Customer. Every TopCoin. All Securely Stored on Our Private
              Blockchain.
            </p>
            <p className="text-dark fw-bold opacity-50 ">
              TopCoin UK runs on its own secure and private blockchain system,
              built to track every free TopCoin given, every wallet unlocked, and
              every reward earned.
            </p>
            <p className="text-dark fw-bold opacity-50 ">
              When a customer shops at a participating business, they’re
              automatically added to the TopCoin UK blockchain, this ensures
              full transparency, trust, and security.
            </p>

            {/* <ul className="unordered_list_block">
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="ico_problem_solution_table mb-3 rounded-3 card"
              >
                <div className="card-body p-4">
                  <ul className="text-white list-unstyled opacity-50">
                    <li className="py-1">
                      <div className="d-flex gap-3 align-items-center">
                        <div>
                          <img src={wallet} width={24} alt="" />
                        </div>
                        <div>Each TopCoin UK Cash Wallet  contains a set amount of money.</div>
                      </div>
                    </li>
                    <li className="py-1">
                      <div className="d-flex gap-3 align-items-center">
                        <div>
                          <img src={users} width={24} alt="" />
                        </div>
                        <div>Every unit is recorded and traceable</div>
                      </div>
                    </li>
                    <li className="py-1">
                      <div className="d-flex gap-3 align-items-center">
                        <div>
                          <img src={sheild} width={24} alt="" />
                        </div>
                        <div>
                          No one can lose value or be skipped - the blockchain
                          protects your progress
                        </div>
                      </div>
                    </li>
                    <li className="py-1">
                      <div className="d-flex gap-3 align-items-center">
                        <div>
                          <img src={network} width={24} alt="" />
                        </div>
                        <div>
                          Each business creates its own chain under the TopCoin
                          UK network
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>
            </ul> */}
            <p className="text-dark fw-bold opacity-50 mb-0">
              No app, no crypto wallet, and no technical knowledge needed.
            </p>
            <p className="text-dark fw-bold opacity-50 ">
              Just shop, collect TopCoin, and watch your wallets grow, all
              securely powered by blockchain technology.
            </p>
          </div>
          <div className="col-lg-5 d-lg-flex flex-lg-column-reverse">
            <div className="ico_about_image text-center d-none d-lg-block">             
              <div className="coin_image">
                <img src={blockchain} className="" alt="" />
              </div>
            </div>
            <div className=" d-block d-lg-none">
<img src={blockchain} className="" alt="" />
            </div>
              
          </div>
        </div>
      </div>

    </section>
  );
};

export default BlockChainContent;
